import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      "& button": {
        minWidth: "auto",
        outline: "0 !important"
      }
    },
    messagePaneRoot: {
      width: "100%",
      position: "absolute",
      bottom: 60,
      right: 2
    },
    messageBubbleContainer: {
      display: "flex",
      justifyContent: "space-between",
      margin: 15,
      marginTop: 25
    },
    botText: {
      padding: 15,
      maxWidth: "85%",
      // backgroundColor: '#8fccc1',
      backgroundColor: "#9ee0d469",
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
      borderBottomLeftRadius: 15,
      color: "#383838",
      whiteSpace: "pre-line"
    },
    userText: {
      padding: 12,
      paddingLeft: 20,
      maxWidth: "85%",
      backgroundColor: "#e8e8e8",
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
      borderBottomRightRadius: 15,
      whiteSpace: "pre-line"
    },
    messagePaneRootText: {
      display: "flex",
      width: "90%",
      flexDirection: "column",
      justifyContent: "center",
      margin: "5%",
      marginBottom: 10,
      padding: 30,
      border: "2px solid #ebebeb",
      borderRadius: 7,
      backgroundColor: "#fff",
      color: "black"
    },
    textMain: {
      [theme.breakpoints.down("sm")]: {
        marginLeft: "5%"
      },
      [theme.breakpoints.up("md")]: {
        marginLeft: "27%"
      },
      [theme.breakpoints.up("lg")]: {
        marginLeft: "43%",
        overflow: "hidden"
      },
      // maxWidth: '400px !important',
      overflowX: "hidden",
      "& div": {
        scrollbarColor: "transparent transparent"
      },
      "& div::-webkit-scrollbar": {
        width: "0px !important",
        background: "transparent"
      },
      "& div::-webkit-scrollbar-thumb": {
        background: "transparent"
      }
    },
    arrowMain: {
      [theme.breakpoints.down("sm")]: {
        maxHeight: "18px",
        transform: "rotate(-58deg)",
        marginTop: "-42px",
        right: "269px"
      },
      [theme.breakpoints.up("md")]: {
        maxHeight: "38px",
        transform: "rotate(-19deg)",
        marginTop: "-57px"
      },
      [theme.breakpoints.up("lg")]: {
        maxHeight: "29px",
        transform: "rotate(-30deg)",
        marginTop: "-48px"
      },
      position: "absolute",
      height: "210px",
      zIndex: 999,
      right: "280px",
    },
    SelectImg: {
      position: "absolute",
      width: "21px",
      height: "auto",
      marginLeft: "1px",
      textAlign: "left",
      justifyContent: "left",
      marginTop: "5px"
    },
    textData: {
      marginBottom: 15
    },
    textMsg: {
      textAlign: "left"
    },
    chathei: {
      height: 40
    },
    timestamp: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: -15
    },
    messageActions: {
      padding: 15
    },
    messageActionsAction: {
      marginLeft: 10,
      padding: 10
    },
    rootRadio: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    icon: {
      borderRadius: '50%',
      width: 16,
      height: 16,
      boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
      backgroundColor: '#f5f8fa',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
      '$root.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },
      'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
      },
    },
    checkedIcon: {
      backgroundColor: '#137cbd',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
      },
      'input:hover ~ &': {
        backgroundColor: '#106ba3',
      },
    },
  });
